export default "__VITE_ASSET__CUt98409__$_?component__"